import { combineEpics } from 'redux-observable';
import { of, fromPromise } from '../common/rxjs/observable';
import { tap, mergeMap, map, switchMap, startWith, catchError, ignoreElements } from '../common/rxjs/operators';
import { delay } from 'rxjs/operators/delay';
import { ProfileActionTypes, FetchProfile, FetchIsScimUser, UpdateProfile, UpdatePassword, UpdateBlankProfile, ResetPassword, DeleteSelf, FetchProfileActionTypes, LOGOUT, LOGOUT_ALL_SESSIONS, DeleteSelfActionTypes, logout as logoutAction } from '../actions/ProfileActions';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ProfileAPI from '../api/ProfileAPI';
import { getFetchProfileRequestStatus, getFetchIsScimUserRequestStatus, getUpdateProfileRequestStatus, getResetPasswordRequestStatus, getDeleteSelfRequestStatus } from '../selectors/RequestStatusSelector';
import PasswordActions from '../password/actions';
import SendAsEmailsActions from '../send-as-emails/actions';
import { createAction } from '../common/actions';
import UsersAPI from '../api/UsersAPI';
import { tracker } from '../lib/tracker';
import { LOGOUT_API, LOGOUT_ALL_DEVICES_API } from '../constants/LoginUrls';
import { RequestEpicDescriptor, requestEntity } from 'settings-ui-lib/utils/epics';
const fetchProfile = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.getProfile,
  initiatingActionType: ProfileActionTypes.LOAD_PROFILE,
  requestActions: FetchProfile,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestStatusSelector: getFetchProfileRequestStatus
}));
const fetchIsScimUser = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.getIsScimUser,
  initiatingActionType: ProfileActionTypes.LOAD_IS_SCIM_USER,
  requestActions: FetchIsScimUser,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED],
  requestStatusSelector: getFetchIsScimUserRequestStatus
}));
export const updateProfile = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.updateProfile,
  initiatingActionType: ProfileActionTypes.UPDATE_PROFILE,
  requestActions: UpdateProfile,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getUpdateProfileRequestStatus
}));
const updateBlankProfile = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.updateProfile,
  initiatingActionType: ProfileActionTypes.UPDATE_BLANK_PROFILE,
  requestActions: UpdateBlankProfile,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getUpdateProfileRequestStatus
}));
const updatePassword = action$ => action$.ofType(ProfileActionTypes.UPDATE_PASSWORD).pipe(switchMap(action => fromPromise(ProfileAPI.updatePassword(action.payload.data)).pipe(map(() => UpdatePassword.success()), catchError(err => {
  return err.status === 400 ? of(UpdatePassword.success(err, undefined)) : of(UpdatePassword.failure(err, undefined));
}), startWith(UpdatePassword.request()))));
const resetPassword = requestEntity(new RequestEpicDescriptor({
  apiFunction: ProfileAPI.resetPassword,
  initiatingActionType: ProfileActionTypes.RESET_PASSWORD,
  requestActions: ResetPassword,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getResetPasswordRequestStatus
}));
const passwordGlue = action$ => action$.ofType(FetchProfileActionTypes.SUCCESS).pipe(mergeMap(action => of(createAction(PasswordActions.LOAD_SUCCESS, action.payload.data.passwordUpdatedAt))));
const sendAsEmailsGlue = action$ => action$.ofType(FetchProfileActionTypes.SUCCESS).pipe(mergeMap(action => {
  let payload = null;
  // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
  if (action.payload.data.canSendAsEmails) {
    // @ts-expect-error ts-migrate(2571) FIXME: Object is of type 'unknown'.
    payload = action.payload.data.sendAsEmails;
  }
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'LOAD_SUCCESS' does not exist on type '{}... Remove this comment to see the full error message
  return of(createAction(SendAsEmailsActions.LOAD_SUCCESS, payload));
}));
const deleteSelf = requestEntity(new RequestEpicDescriptor({
  apiFunction: UsersAPI.deleteSelf,
  initiatingActionType: ProfileActionTypes.DELETE_SELF,
  requestActions: DeleteSelf,
  requestStatusTypeFilters: [RequestStatusTypes.UNINITIALIZED, RequestStatusTypes.SUCCEEDED, RequestStatusTypes.FAILED],
  requestStatusSelector: getDeleteSelfRequestStatus
}));
const postDelete = action$ => action$.ofType(DeleteSelfActionTypes.SUCCESS).pipe(tap(() => tracker.track('usage', {
  action: 'gdprDelete'
})), delay(3000), map(() => logoutAction()));
const logout = action$ => action$.ofType(LOGOUT).pipe(
// @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
tap(() => window.location = LOGOUT_API), ignoreElements());
const logoutAllSessions = action$ => action$.ofType(LOGOUT_ALL_SESSIONS).pipe(
// @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'Location'... Remove this comment to see the full error message
tap(() => window.location = LOGOUT_ALL_DEVICES_API), ignoreElements());
export default combineEpics(fetchProfile, fetchIsScimUser, updatePassword, updateBlankProfile, resetPassword, passwordGlue, sendAsEmailsGlue, deleteSelf, postDelete, logout, logoutAllSessions);